import { Calendar } from "lucide-react";

interface LastUpdatedProps {
  date: string; // ISO date string or German formatted date
}

export const LastUpdated = ({ date }: LastUpdatedProps) => {
  // Try to parse as ISO date, if fails use the string directly
  const parsedDate = new Date(date);
  const isValidDate = !isNaN(parsedDate.getTime());
  
  const formattedDate = isValidDate 
    ? parsedDate.toLocaleDateString('de-DE', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : date; // Use as-is if it's already formatted

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground my-4">
      <Calendar className="h-4 w-4" />
      <span>Zuletzt aktualisiert: {formattedDate}</span>
    </div>
  );
};
